var artFull = document.querySelector('[data-article-full]')

if (artFull) {
	var share = artFull.querySelector('.share')
	var artsectioncards = artFull.querySelector('.art-section-cards')

	if (share && artsectioncards) {
		share.parentNode.insertBefore(share, artsectioncards)
	}
}
